import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  MenuItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { getUsers } from "../api";
import { AuthContext } from "../../../../../context/authContext";
import { PROJECT_TYPES } from "../../../../../constants/projectTypes";

const roles = ["Project Manager", "Engineer", "Senior Engineer"];

const CreateProjectDialog = ({ open, onClose, onSave }) => {
  const [projectName, setProjectName] = useState("");
  const [sharepointLink, setSharepointLink] = useState("");
  const [members, setMembers] = useState([]);
  const [newMemberId, setNewMemberId] = useState("");
  const [newMemberRole, setNewMemberRole] = useState(roles[0]);
  const [users, setUsers] = useState([]);
  const { accessToken } = useContext(AuthContext);
  const [selectedType, setSelectedType] = useState();
  const types = PROJECT_TYPES;

  // useEffect(() => {
  //   const fetchUsers = async () => {
  //     try {
  //       const response = await getUsers(accessToken);
  //       setUsers(response); // Assuming the API returns an array of users
  //     } catch (error) {
  //       console.error("Error fetching users:", error);
  //     }
  //   };

  //   fetchUsers();
  // }, [accessToken]);

  // const addMember = () => {
  //   const selectedUser = users.find((user) => user.id === newMemberId);
  //   if (selectedUser) {
  //     setMembers((prev) => [
  //       ...prev,
  //       { id: newMemberId, name: selectedUser.username, role: newMemberRole },
  //     ]);
  //     setNewMemberId("");
  //     setNewMemberRole(roles[0]);
  //   }
  // };

  // const removeMember = (index) => {
  //   setMembers((prev) => prev.filter((_, i) => i !== index));
  // };

  const handleSave = () => {
    if (projectName) {
      //   console.log('ddd', onSave);

      onSave({ projectName, sharepointLink, members, selectedType });
      setProjectName("");
      selectedType("");
      setMembers([]);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Create New Project</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          label="Project Name"
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
          fullWidth
        />
        <TextField
          label="Sharepoint Link (optional)"
          value={sharepointLink}
          onChange={(e) => setSharepointLink(e.target.value)}
          fullWidth
        />
        <TextField
          label="Type"
          select
          defaultValue={types[0].value}
          fullWidth
          onChange={(e) => {
            console.log("selected type", e.target.value);

            setSelectedType(e.target.value);
          }}
          value={selectedType}
        >
          {types.map((t) => (
            <MenuItem key={t.value} value={t.value}>
              {t.label}
            </MenuItem>
          ))}
        </TextField>
        {/* <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <TextField
            label="Member Name"
            select
            value={newMemberId}
            onChange={(e) => setNewMemberId(e.target.value)}
            sx={{ flex: 1 }}
          >
            {users.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                {user.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Role"
            select
            value={newMemberRole}
            onChange={(e) => setNewMemberRole(e.target.value)}
            sx={{ flex: 1 }}
          >
            {roles.map((role) => (
              <MenuItem key={role} value={role}>
                {role}
              </MenuItem>
            ))}
          </TextField>
          <Button
            variant="contained"
            onClick={addMember}
            disabled={!newMemberId || !newMemberRole}
          >
            Add Member
          </Button>
        </Box> */}
        {/* <Box>
          {members.map((member, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 1,
              }}
            >
              {`${member.name} (${member.role})`}
              <IconButton onClick={() => removeMember(index)}>
                <DeleteIcon />
              </IconButton>
            </Box>
          ))}
        </Box> */}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={!projectName || !selectedType}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateProjectDialog;
